// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:768px){.countries-list[data-v-50dc838d]{padding:0 4em}}@media(max-width:480px){.countries-list[data-v-50dc838d]{padding:0 2em}}.countries-list__list[data-v-50dc838d]{text-align:start}", ""]);
// Exports
module.exports = exports;
